import { Component, Input } from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwFab
 * @module mw.components.fab
 *
 * @param {boolean} [is-pulsing=false] - It activates the pulsing animation.
 * @param {string} [label='Actions'] - Tooltip text.
 * @param {string} [svg-src] - md-icon to show (doesn't work when used as trigger button).
 * @param {boolean} [is-fixed=false] - Use it when FAB is inside a scrollable container.
 *
 * @description
 * `<mw-fab>` is a component that wraps an standard md-button with a md-icon
 *
 * @usage
 * <hljs hljs-language="html">
 *   <mw-fab svg-src="content:ic_add_24px" label="Add" is-pulsing="false"></mw-fab>
 * </hljs>
 *
 */
@Component({
    selector: 'mw-fab',
    template: `
        <md-button aria-label="{{$ctrl.label}}" class="mw-button md-fab mw-fab md-fab-bottom-right" ng-class="{ 'mw-fab--pulsing':$ctrl.isPulsing, 'mw-fab--fixed':$ctrl.isFixed}" ng-click="$ctrl.onClickFab($event)">
            <md-icon md-svg-src="{{$ctrl.svgSrc}}"></md-icon>
            <div class="mw-fab-trigger-button__hamburger-icon">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <md-tooltip md-direction="left">
                {{$ctrl.label}}
            </md-tooltip>
        </md-button>
    `
})
export class FabComponent {

    @Input('<') isPulsing: boolean = false;
    @Input('<') isFixed: boolean = false;
    @Input('@') label: string = 'Actions';
    @Input('@') svgSrc: string;

    constructor() {
        'ngInject';
    }

    onClickFab(event) {
        if (this.isPulsing) this.isPulsing = false;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/fab/fab.component.ts